import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'

export const Macroeconomic = () => {
  return (
    <Element
      className="fw600 textUppercase"
      style={{ fontSize: 24, color: '#0553A5' }}
    >
      <Translate value="alertDetail.MACROECONOMIC" />
    </Element>
  )
}
